// ----------------------------------------------------------------------

export const paths = {
  home: '/',
  login: '/login',
  forgotPassword: '/forgot-password',
  activateAccount: '/activate-account',
  dashboard: {
    root: '/dashboard',
    wachtwoord: '/dashboard/wachtwoord',
    locaties: '/dashboard/locaties',
    locatieDetail: (locationId: string) =>
      `/dashboard/locaties/${encodeURIComponent(locationId)}`,
    rapportages: '/dashboard/rapportages',
    certificaten: '/dashboard/certificaten',
    offertes: '/dashboard/offertes',
    contracten: '/dashboard/contracten',
    mjop: '/dashboard/mjop',
    mjopDetail: (publicOfferId: string) =>
      `/dashboard/mjop/${encodeURIComponent(publicOfferId)}`,
  },
  errors: {
    forbidden: '/error/403',
    notFound: '/error/404',
    server: '/error/500',
  },
} as const;
